import { useHotkeys } from "react-hotkeys-hook";
import { toast } from "sonner";

export function useDismissToastsShortcut() {
  useHotkeys("escape", () => toast.dismiss());
}
